module.exports = __webpack_public_path__ + "img/34.f85fa4d4.jpg";